module.exports = __webpack_public_path__ + "img/item1.d966e7c0.svg";